module.exports = __webpack_public_path__ + "img/logo1.3a082931.png";